import { useIntl } from "react-intl";

import { InfoText } from "@/components/info-text/src";
import { ProTipComponent } from "@/templates/agile-hub/types";

export type ProTipTextComponentProps = Omit<ProTipComponent, "__typename">;
export const ProTipTextComponent = (data: ProTipTextComponentProps) => {
    const intl = useIntl();

    return (
        <InfoText
            text={data.proTipText as string}
            headingText={intl.formatMessage({
                id: "agile.overview.protip",
                defaultMessage: "Pro Tip:"
            })}
        />
    );
};
